$('.footer--accordion-item .footer--section-header').on('click', function(e) {
    const isPlaceholderLink = $(this).attr('href') === '#';
    if (isPlaceholderLink) {
        e.preventDefault();
    }
    if ($(window).width() < 960 && (isPlaceholderLink || !$(e.target).closest('.text').length)) {
        const item = $(this).closest('.footer--accordion-item');
        const content = item.find('.footer--section-content');
        if (!content.length) return;
        e.preventDefault();
        if (item.hasClass('is-open')) {
            item.removeClass('is-open');
            $(this).attr('aria-expanded', 'false');
            content.slideUp(500);
        } else {
            item.addClass('is-open');
            $(this).attr('aria-expanded', 'true');
            content.slideDown(500);
        }
    }
});
